import React from "react";
import { FaYoutube, FaInstagram, FaFacebook } from "react-icons/fa";

interface TrackerData {
  exact?: boolean;
  suggestion?: string;
}

interface SourceData {
  id: string;
  icon: React.ReactNode;
  trackers: Record<string, TrackerData>;
  maintenance?: boolean;
}

export const sourcesData: Record<string, SourceData> = {
  youtube: {
    id: "youtube",
    icon: <FaYoutube className="text-red-500" />,
    trackers: {
      keywords: {
        exact: true,
      },
      hashtag: {},
      video: {},
    },
  },
  instagram: {
    id: "instagram",
    icon: <FaInstagram className="text-pink-500" />,
    trackers: {},
    maintenance: true,
  },
  facebook: {
    id: "facebook",
    icon: <FaFacebook className="text-blue-600" />,
    trackers: {
      keywords: {},
      group: {
        suggestion: "facebook_search_groups",
      },
      album: {},
      comments: {},
      hashtag: {},
      profile: {},
      event: {},
    },
  },
};

export const sources = ["twitter", "press", "instagram", "youtube", "facebook", "tiktok"];
export const sourcesMaintenance = ["instagram"];
